import { TypeOffre } from '@/enum/TypeOffre'
import { ExportCatalogType } from '@/enum/ExportCatalogType'


//Représente des informations d'indentification d'un utilisateur
export interface AloUserIdentity {
    userLogin:string
    userPass:string
}

export const getDefaultAloUserIdentity = ():AloUserIdentity => {
    return {        
        userLogin:"",
        userPass:""
    }
}